/* Core & libraries */
import React, { useEffect } from 'react';
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useAnalytics } from "../../../../hooks/useAnalytics";
import { AIRLINES, PAGE_TITLES } from "../../../../constants/appConstants";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { usePowerBiService } from '../../../../services/powerBiService';
import { useUserContext } from "../../../../contexts/userContext";

/* Components */
import PowerBi from "../../../powerBi";

/* Styles */
import styles from "./styles.js"


const SummaryTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { initAnalytics } = useAnalytics();
  const userDetails = useUserContext();
  const { checkPermission } = useHasPermission();
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const { summaryPowerBiConfig, getSummaryPowerBiConfig } = usePowerBiService()

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["summary"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    (async () => {
      await getSummaryPowerBiConfig(companyEntityId);
    })();
  }, []);

  return(
    <div className={classes.summaryTab}>
      {
        providerCode === AIRLINES.AA && checkPermission("F_VIEW_REPORT_SUMMARY_POWERBI") &&
        <PowerBi powerBiConfig={summaryPowerBiConfig}/>
      }
    </div>
  )

}
export default SummaryTab;